import { DocumentCard } from "@fluentui/react";
import { getNextColor } from "@fluentui/react-charting";
import { Card, FluentProvider, webLightTheme } from "@fluentui/react-components";
import { useContext, useRef } from "react";
import DisplayAPIsException from "../../../BasicComponents/DisplayAPIsExceptionAlert";
import { CustomShimmer } from "../../../helper/CustomShimmer";
import { CustomMetricsCard } from "../../../SharedComponents/CustomMetricsCard";
import { arrSortAscByKeyValue } from "../../../Utils/js-common";
import { PRODUCT_VIEW_DATA } from "../Common/ProductView.constants";
import { PRODUCT_VIEW_STYLES } from "../Common/ProductView.styles";
import { OverviewAndSummaryMutationContext } from "../ProductView";

export function ProductViewOverviewContainer() {
  const documentCardRef = useRef<HTMLDivElement>(null);
  const { data, error, isError, isLoading } = useContext(OverviewAndSummaryMutationContext);

  const getOverviewData = (data: any[]) => {
    const sortedData = arrSortAscByKeyValue({
      key: "productKPIName",
      data: JSON.parse(JSON.stringify(data))
    });

    return sortedData.map((index, id: number) => ({
      title: index.productKPIName,
      description: index.productKPIDescription,
      currentValue: index.currentValue,
      abbrevatedValue: index.abbrevatedValue,
      color: getNextColor(id)
    }));
  };

  const displayContents = (
    <FluentProvider theme={webLightTheme}>
      <Card style={PRODUCT_VIEW_STYLES.OVERVIEW_SECTOIN.cardContent}>
        {data?.overviewData && data.overviewData.length > 0 ? (
          <div style={{ display: "flex", gap: "16px", flexWrap: "wrap", padding: "10px" }}>
            {getOverviewData(data.overviewData).map((cardData, index) => (
              <CustomMetricsCard
                key={`metric-card-${index}`}
                title={cardData.title}
                description={cardData.description}
                currentValue={cardData.currentValue}
                abbrevatedValue={cardData.abbrevatedValue}
                color={cardData.color}
              />
            ))}
          </div>
        ) : (
          <div style={PRODUCT_VIEW_STYLES.OVERVIEW_SECTOIN.NoDataStyles}>
            {PRODUCT_VIEW_DATA.PRODUCT_VIEW.CARD_N0_DATA_MESSAGE}
          </div>
        )}
      </Card>
    </FluentProvider>
  );

  if (!isLoading && isError) {
    return (
      <div ref={documentCardRef} style={PRODUCT_VIEW_STYLES.OVERVIEW_SECTOIN.overviewContainer}>
        <DocumentCard styles={{ root: PRODUCT_VIEW_STYLES.OVERVIEW_SECTOIN.cardRoot }}>
          <DisplayAPIsException error={error} height={documentCardRef.current?.offsetHeight} />
        </DocumentCard>
      </div>
    );
  }

  return (
    <div ref={documentCardRef} style={PRODUCT_VIEW_STYLES.OVERVIEW_SECTOIN.overviewContainer}>
      <DocumentCard styles={{ root: PRODUCT_VIEW_STYLES.OVERVIEW_SECTOIN.cardRoot }}>
        {isLoading ? (
          <CustomShimmer rowCount={1} columnCount={4} styles={PRODUCT_VIEW_STYLES.OVERVIEW_SECTOIN.shimmerStyles} />
        ) : (
          displayContents
        )}
      </DocumentCard>
    </div>
  );
}
